import makeAsyncScriptLoader from 'react-async-script';

const ZoomLib = ({ onLoad }) => {
    return null;
}

const ZoomLibWrapper = makeAsyncScriptLoader('https://appssdk.zoom.us/sdk.min.js')(ZoomLib);
export default ZoomLibWrapper;
